import type { TSliceReducer } from 'core/store';
import { initialState } from './constants';
import type { IPlatformState } from './types';

export const clearPlatformState: TSliceReducer<IPlatformState> = state => {
  Object.assign(state, initialState);
};

export const setSelectedPlatform: TSliceReducer<IPlatformState, number> = (state, action) => {
  state.selectedPlatform = action.payload;
};

export const reducers = { clearPlatformState, setSelectedPlatform };
